import React from 'react';
import styles from './CompanySelector.module.css';

export default function CompanySelector({ companies, selected, onChange }) {
  return (
    <div className={styles.selector}>
      <label htmlFor="company-select">Select Company:</label>
      <select
        id="company-select"
        value={selected || ''}
        onChange={(e) => onChange(parseInt(e.target.value) || null)}
        className={styles.select}
      >
        <option value="">-- Choose a company --</option>
        {companies.map((company) => (
          <option key={company.id} value={company.id}>
            {company.name}
          </option>
        ))}
      </select>
    </div>
  );
}
